// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Notifications: the top-bar bell (.nf-bell*), its dropdown (.nf-panel*),
   the /notifications feed page (.nf-page*) and the incoming work-order
   transfer screens (.tr-*). Colours are written out so the sheet reads the
   same inside the AppShell and anywhere else it might be mounted. */

/* ---------------- bell (in .rf-topbar, a brand-gold band) ---------------- */
.nf-bell-wrap {
  position: relative;
  flex-shrink: 0;
}
.nf-bell {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: transparent;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  transition: background 150ms, border-color 150ms;
}
.nf-bell:hover,
.nf-bell.is-open {
  background: rgba(255, 255, 255, 0.16);
  border-color: #fff;
}
.nf-bell.has-new {
  animation: nf-ring 900ms ease-in-out 1;
}
@keyframes nf-ring {
  0%, 100% { transform: rotate(0); }
  20% { transform: rotate(14deg); }
  40% { transform: rotate(-12deg); }
  60% { transform: rotate(8deg); }
  80% { transform: rotate(-4deg); }
}
.nf-badge {
  position: absolute;
  top: -5px;
  right: -6px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #b83a2f;
  color: #fff;
  font: 700 10.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  line-height: 18px;
  text-align: center;
  border: 2px solid var(--rf-header);
  box-sizing: content-box;
  font-variant-numeric: tabular-nums;
}

/* ---------------- dropdown ---------------- */
.nf-panel {
  position: absolute;
  top: 46px;
  right: 0;
  width: 400px;
  max-width: calc(100vw - 32px);
  background: #fff;
  color: #191714;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  box-shadow: 0 14px 40px rgba(25, 23, 20, 0.18);
  z-index: 40;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  text-align: left;
  font-weight: normal;
}
.nf-panel-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px 10px;
  border-bottom: 1px solid #efebe2;
}
.nf-panel-title {
  font-size: 14px;
  font-weight: 600;
}
.nf-panel-count {
  font-size: 11.5px;
  color: #8b8477;
}
.nf-link {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-brand);
}
.nf-link:hover {
  color: var(--rf-brand-hover);
  text-decoration: underline;
}
.nf-link:disabled {
  color: #bdb6a7;
  cursor: default;
  text-decoration: none;
}
.nf-panel-list {
  max-height: 420px;
  overflow-y: auto;
}
.nf-panel-foot {
  border-top: 1px solid #efebe2;
  padding: 10px 14px;
  display: flex;
  justify-content: center;
}
.nf-empty {
  padding: 28px 16px;
  text-align: center;
  color: #8b8477;
  font-size: 13px;
}

/* One notification row — shared by the dropdown and the feed page. */
.nf-item {
  display: flex;
  gap: 12px;
  width: 100%;
  padding: 11px 14px;
  border: none;
  border-bottom: 1px solid #f3f0e8;
  background: #fff;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  color: inherit;
  transition: background 120ms;
}
.nf-item:last-child {
  border-bottom: none;
}
.nf-item:hover {
  background: #fdfbf6;
}
.nf-item.is-viewed {
  background: #fff;
}
.nf-item.is-viewed .nf-item-title {
  font-weight: 500;
  color: #6f6a60;
}
.nf-item.is-viewed .nf-item-msg {
  color: #a29b8d;
}
.nf-item-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--rf-brand-lite);
  flex-shrink: 0;
  margin-top: 6px;
}
.nf-item.is-viewed .nf-item-dot {
  background: transparent;
  border: 1px solid #e2dcd0;
}
.nf-item-body {
  min-width: 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.nf-item-top {
  display: flex;
  align-items: baseline;
  gap: 8px;
}
.nf-item-title {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
  flex-grow: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nf-item-time {
  font-size: 11px;
  color: #a29b8d;
  white-space: nowrap;
  flex-shrink: 0;
}
.nf-item-msg {
  font-size: 12.5px;
  color: #4a453c;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.nf-item-meta {
  font-size: 11px;
  color: #a29b8d;
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.nf-type {
  display: inline-block;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--rf-brand);
  background: var(--rf-brand-tint);
  border-radius: 4px;
  padding: 1px 6px;
}

/* ---------------- feed page ---------------- */
.nf-page,
.tr-page {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
  -webkit-font-smoothing: antialiased;
  padding-bottom: 32px;
}
.nf-page *,
.tr-page * {
  box-sizing: border-box;
}
.nf-head,
.tr-head {
  padding: 22px 28px 0;
  display: flex;
  align-items: flex-end;
  gap: 18px;
  flex-wrap: wrap;
  margin: 0;
  text-align: left;
  font-weight: normal;
}
.nf-head-text,
.tr-head-text {
  min-width: 0;
  flex-grow: 1;
}
.nf-title,
.tr-title {
  font-family: "Instrument Serif", Georgia, serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 1.15;
  margin: 0;
}
.nf-lede,
.tr-lede {
  font-size: 13px;
  color: #6f6a60;
  margin: 4px 0 0;
}
.nf-head-actions,
.tr-head-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}
.nf-toolbar {
  padding: 16px 28px 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.nf-select {
  height: 34px;
  padding: 0 10px;
  border: 1px solid #e7e3da;
  border-radius: 8px;
  background: #fff;
  font: 500 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #4a453c;
}
.nf-feed {
  margin: 0 28px;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
}
.nf-feed .nf-item {
  padding: 14px 18px;
}
.nf-item-actions {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0;
  align-self: center;
}
.nf-pager {
  margin: 14px 28px 0;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12.5px;
  color: #6f6a60;
}
.nf-pager .rf-spacer {
  flex-grow: 1;
}
.nf-error {
  margin: 0 28px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #f7ebe9;
  color: #a8483e;
  font-size: 13px;
}
.nf-toast b {
  display: block;
  margin-bottom: 2px;
}
.nf-toast span {
  font-size: 12.5px;
  opacity: 0.85;
}

/* ---------------- incoming transfer ---------------- */
.tr-crumb {
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  font: 600 12px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: var(--rf-brand);
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
}
.tr-crumb:hover {
  text-decoration: underline;
}
.tr-pill {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border-radius: 999px;
  padding: 3px 10px;
  vertical-align: middle;
  margin-left: 10px;
}
.tr-pill.is-pending { background: #f9f1de; color: #b0872f; }
.tr-pill.is-accepted { background: #eaf1e9; color: #4d7a52; }
.tr-pill.is-rejected { background: #f7ebe9; color: #a8483e; }
.tr-pill.is-cancelled { background: #eeeae1; color: #8b8477; }

.tr-grid {
  margin: 18px 28px 0;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 18px;
  align-items: start;
}
@media (max-width: 1100px) {
  .tr-grid {
    grid-template-columns: 1fr;
  }
}
.tr-col {
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 0;
}
.tr-card {
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  padding: 18px 20px;
}
.tr-card-title {
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #8b8477;
  margin: 0 0 12px;
}
.tr-kv {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px 20px;
  margin: 0;
}
.tr-kv > div {
  min-width: 0;
}
.tr-kv dt {
  font-size: 11px;
  color: #a29b8d;
  margin: 0 0 2px;
}
.tr-kv dd {
  font-size: 13.5px;
  color: #191714;
  margin: 0;
  word-break: break-word;
}
.tr-kv dd.is-empty {
  color: #bdb6a7;
}
.tr-note {
  margin: 0;
  padding: 12px 14px;
  border-left: 3px solid var(--rf-brand-lite);
  background: #fdfbf6;
  border-radius: 0 8px 8px 0;
  font-size: 13.5px;
  color: #4a453c;
  line-height: 1.45;
}
.tr-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.tr-table th {
  text-align: left;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8b8477;
  padding: 6px 8px;
  border-bottom: 1px solid #e7e3da;
}
.tr-table td {
  padding: 8px;
  border-bottom: 1px solid #f3f0e8;
  vertical-align: top;
}
.tr-table tr:last-child td {
  border-bottom: none;
}
.tr-table .is-num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.tr-table .is-muted {
  color: #8b8477;
  font-size: 12px;
}
.tr-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.tr-actions .rf-btn {
  width: 100%;
}
.rf-btn-danger {
  padding: 0 14px;
  border: 1px solid #e6c9c4;
  background: #fff;
  color: #a8483e;
}
.rf-btn-danger:hover {
  background: #f7ebe9;
}
.rf-btn:disabled {
  opacity: 0.55;
  cursor: default;
}
.tr-textarea {
  width: 100%;
  min-height: 70px;
  resize: vertical;
  padding: 8px 10px;
  border: 1px solid #e7e3da;
  border-radius: 8px;
  font: 400 13px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #191714;
}
.tr-textarea:focus {
  outline: none;
  border-color: var(--rf-brand-lite);
}
.tr-help {
  font-size: 12px;
  color: #8b8477;
  margin: 0;
  line-height: 1.45;
}
.tr-blockers {
  border: 1px solid #ead9b3;
  background: #fbf6ea;
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.tr-blockers-title {
  font-size: 13px;
  font-weight: 600;
  color: #7d5f24;
  margin: 0;
}
.tr-blocker {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  font-size: 13px;
  color: #4a453c;
}
.tr-blocker input {
  margin-top: 3px;
  accent-color: var(--rf-brand);
}
.tr-blocker ul {
  margin: 4px 0 0;
  padding-left: 16px;
  font-size: 12px;
  color: #6f6a60;
}
.tr-blocker.is-hard {
  color: #a8483e;
}
.tr-result {
  border: 1px solid #cfe0d0;
  background: #eaf1e9;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 13px;
  color: #35563a;
  line-height: 1.5;
}
.tr-result ul {
  margin: 6px 0 0;
  padding-left: 16px;
}
.tr-decided {
  font-size: 13px;
  color: #4a453c;
  line-height: 1.5;
}
.tr-noperm {
  border: 1px solid #e7e3da;
  background: #fdfcfa;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 13px;
  color: #6f6a60;
  line-height: 1.5;
}
.tr-state {
  margin: 24px 28px;
  color: #8b8477;
  font-size: 13.5px;
}

/* incoming transfers list */
.tr-list {
  margin: 18px 28px 0;
  background: #fff;
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
}
.tr-list .tr-table th:first-child,
.tr-list .tr-table td:first-child {
  padding-left: 18px;
}
.tr-list .tr-table th:last-child,
.tr-list .tr-table td:last-child {
  padding-right: 18px;
}
.tr-list .tr-table td {
  padding-top: 11px;
  padding-bottom: 11px;
}
.tr-row {
  cursor: pointer;
}
.tr-row:hover td {
  background: #fdfbf6;
}
.tr-serial {
  font-weight: 600;
  white-space: nowrap;
}
.tr-list .tr-pill {
  margin-left: 0;
}

/* ---------------- transfers page tabs ---------------- */
.tr-tabs {
  display: flex;
  gap: 4px;
  margin-top: 18px;
  border-bottom: 1px solid #e8e2d6;
}
.tr-tab {
  border: none;
  background: transparent;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #8b8477;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  transition: color 150ms, border-color 150ms;
}
.tr-tab:hover {
  color: #5d574c;
}
.tr-tab.is-active {
  color: var(--rf-brand-deep);
  border-bottom-color: var(--rf-brand-lite);
}
.tr-list .tr-table .tr-rowact {
  text-align: right;
  white-space: nowrap;
}
.tr-list .tr-table .tr-rowact .rf-btn {
  padding: 3px 12px;
  font-size: 12px;
}

/* ---------------- transfer request modal (source side) ---------------- */
.tx-wrap {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.tx-scrim {
  position: absolute;
  inset: 0;
  background: rgba(25, 23, 20, 0.48);
}
.tx-modal {
  position: relative;
  width: min(520px, 100%);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  background: #fffdf8;
  border: 1px solid #e8e2d6;
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(25, 23, 20, 0.28);
  overflow: hidden;
}
.tx-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 22px 16px;
  border-bottom: 1px solid #efeae0;
}
.tx-head > div {
  flex: 1 1;
  min-width: 0;
}
.tx-eyebrow {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #a39a89;
}
.tx-title {
  font-size: 24px;
  line-height: 1.15;
  margin: 4px 0 0;
  font-weight: 400;
  color: #191714;
}
.tx-sub {
  margin: 4px 0 0;
  font-size: 12.5px;
  color: #6f6a60;
}
.tx-body {
  padding: 18px 22px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.tx-lede {
  margin: 0;
}
.tx-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tx-choices {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.tx-choice {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 10px 13px;
  border: 1px solid #e8e2d6;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: border-color 150ms, background 150ms;
}
.tx-choice:hover {
  border-color: #d8ccb4;
}
.tx-choice.is-on {
  border-color: var(--rf-brand-lite);
  background: #fbf6ea;
}
.tx-choice input {
  accent-color: var(--rf-brand-lite);
  margin: 0;
}
.tx-choice-mark {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #f0e3c8;
  color: var(--rf-brand-deep);
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.tx-choice-name {
  font-size: 13.5px;
  font-weight: 600;
  color: #35312a;
  min-width: 0;
}
.tx-exists {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 14px 16px;
  border-radius: 10px;
  background: #f9f1de;
  border: 1px solid #ecdcb8;
}
.tx-exists b {
  font-size: 13.5px;
  color: var(--rf-brand-deep);
}
.tx-exists p {
  margin: 0;
  font-size: 12.5px;
  color: #8a7f6a;
  line-height: 1.5;
}
.tx-foot {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 22px;
  border-top: 1px solid #efeae0;
  background: #faf6ee;
}
.tx-modal .tr-textarea {
  min-height: 74px;
}
`, "",{"version":3,"sources":["webpack://./src/notifications.css"],"names":[],"mappings":"AAAA;;;oEAGoE;;AAEpE,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gDAAgD;AAClD;AACA;;EAEE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,WAAW,oBAAoB,EAAE;EACjC,MAAM,wBAAwB,EAAE;EAChC,MAAM,yBAAyB,EAAE;EACjC,MAAM,uBAAuB,EAAE;EAC/B,MAAM,wBAAwB,EAAE;AAClC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gEAAgE;EAChE,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,4DAA4D;EAC5D,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,8DAA8D;EAC9D,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;;EAEE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,4DAA4D;EAC5D,cAAc;EACd,mCAAmC;EACnC,oBAAoB;AACtB;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,oBAAoB;EACpB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,YAAY;AACd;AACA;;EAEE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;AACA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,8DAA8D;EAC9D,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;AACA,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;AAC3D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;;AAE7D;EACE,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,4DAA4D;EAC5D,cAAc;EACd,SAAS;AACX;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,8DAA8D;EAC9D,cAAc;AAChB;AACA;EACE,aAAa;EACb,kCAAkC;AACpC;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;AACpB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,2EAA2E;AAC3E;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["/* Notifications: the top-bar bell (.nf-bell*), its dropdown (.nf-panel*),\n   the /notifications feed page (.nf-page*) and the incoming work-order\n   transfer screens (.tr-*). Colours are written out so the sheet reads the\n   same inside the AppShell and anywhere else it might be mounted. */\n\n/* ---------------- bell (in .rf-topbar, a brand-gold band) ---------------- */\n.nf-bell-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n.nf-bell {\n  position: relative;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.45);\n  background: transparent;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 20px;\n  transition: background 150ms, border-color 150ms;\n}\n.nf-bell:hover,\n.nf-bell.is-open {\n  background: rgba(255, 255, 255, 0.16);\n  border-color: #fff;\n}\n.nf-bell.has-new {\n  animation: nf-ring 900ms ease-in-out 1;\n}\n@keyframes nf-ring {\n  0%, 100% { transform: rotate(0); }\n  20% { transform: rotate(14deg); }\n  40% { transform: rotate(-12deg); }\n  60% { transform: rotate(8deg); }\n  80% { transform: rotate(-4deg); }\n}\n.nf-badge {\n  position: absolute;\n  top: -5px;\n  right: -6px;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: #b83a2f;\n  color: #fff;\n  font: 700 10.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  line-height: 18px;\n  text-align: center;\n  border: 2px solid var(--rf-header);\n  box-sizing: content-box;\n  font-variant-numeric: tabular-nums;\n}\n\n/* ---------------- dropdown ---------------- */\n.nf-panel {\n  position: absolute;\n  top: 46px;\n  right: 0;\n  width: 400px;\n  max-width: calc(100vw - 32px);\n  background: #fff;\n  color: #191714;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  box-shadow: 0 14px 40px rgba(25, 23, 20, 0.18);\n  z-index: 40;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  text-align: left;\n  font-weight: normal;\n}\n.nf-panel-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 14px 10px;\n  border-bottom: 1px solid #efebe2;\n}\n.nf-panel-title {\n  font-size: 14px;\n  font-weight: 600;\n}\n.nf-panel-count {\n  font-size: 11.5px;\n  color: #8b8477;\n}\n.nf-link {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-brand);\n}\n.nf-link:hover {\n  color: var(--rf-brand-hover);\n  text-decoration: underline;\n}\n.nf-link:disabled {\n  color: #bdb6a7;\n  cursor: default;\n  text-decoration: none;\n}\n.nf-panel-list {\n  max-height: 420px;\n  overflow-y: auto;\n}\n.nf-panel-foot {\n  border-top: 1px solid #efebe2;\n  padding: 10px 14px;\n  display: flex;\n  justify-content: center;\n}\n.nf-empty {\n  padding: 28px 16px;\n  text-align: center;\n  color: #8b8477;\n  font-size: 13px;\n}\n\n/* One notification row — shared by the dropdown and the feed page. */\n.nf-item {\n  display: flex;\n  gap: 12px;\n  width: 100%;\n  padding: 11px 14px;\n  border: none;\n  border-bottom: 1px solid #f3f0e8;\n  background: #fff;\n  text-align: left;\n  cursor: pointer;\n  font-family: inherit;\n  color: inherit;\n  transition: background 120ms;\n}\n.nf-item:last-child {\n  border-bottom: none;\n}\n.nf-item:hover {\n  background: #fdfbf6;\n}\n.nf-item.is-viewed {\n  background: #fff;\n}\n.nf-item.is-viewed .nf-item-title {\n  font-weight: 500;\n  color: #6f6a60;\n}\n.nf-item.is-viewed .nf-item-msg {\n  color: #a29b8d;\n}\n.nf-item-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--rf-brand-lite);\n  flex-shrink: 0;\n  margin-top: 6px;\n}\n.nf-item.is-viewed .nf-item-dot {\n  background: transparent;\n  border: 1px solid #e2dcd0;\n}\n.nf-item-body {\n  min-width: 0;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.nf-item-top {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n.nf-item-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n  flex-grow: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.nf-item-time {\n  font-size: 11px;\n  color: #a29b8d;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.nf-item-msg {\n  font-size: 12.5px;\n  color: #4a453c;\n  line-height: 1.4;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.nf-item-meta {\n  font-size: 11px;\n  color: #a29b8d;\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n.nf-type {\n  display: inline-block;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n  background: var(--rf-brand-tint);\n  border-radius: 4px;\n  padding: 1px 6px;\n}\n\n/* ---------------- feed page ---------------- */\n.nf-page,\n.tr-page {\n  flex-grow: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n  -webkit-font-smoothing: antialiased;\n  padding-bottom: 32px;\n}\n.nf-page *,\n.tr-page * {\n  box-sizing: border-box;\n}\n.nf-head,\n.tr-head {\n  padding: 22px 28px 0;\n  display: flex;\n  align-items: flex-end;\n  gap: 18px;\n  flex-wrap: wrap;\n  margin: 0;\n  text-align: left;\n  font-weight: normal;\n}\n.nf-head-text,\n.tr-head-text {\n  min-width: 0;\n  flex-grow: 1;\n}\n.nf-title,\n.tr-title {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 1.15;\n  margin: 0;\n}\n.nf-lede,\n.tr-lede {\n  font-size: 13px;\n  color: #6f6a60;\n  margin: 4px 0 0;\n}\n.nf-head-actions,\n.tr-head-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.nf-toolbar {\n  padding: 16px 28px 12px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.nf-select {\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid #e7e3da;\n  border-radius: 8px;\n  background: #fff;\n  font: 500 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #4a453c;\n}\n.nf-feed {\n  margin: 0 28px;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.nf-feed .nf-item {\n  padding: 14px 18px;\n}\n.nf-item-actions {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-shrink: 0;\n  align-self: center;\n}\n.nf-pager {\n  margin: 14px 28px 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 12.5px;\n  color: #6f6a60;\n}\n.nf-pager .rf-spacer {\n  flex-grow: 1;\n}\n.nf-error {\n  margin: 0 28px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  background: #f7ebe9;\n  color: #a8483e;\n  font-size: 13px;\n}\n.nf-toast b {\n  display: block;\n  margin-bottom: 2px;\n}\n.nf-toast span {\n  font-size: 12.5px;\n  opacity: 0.85;\n}\n\n/* ---------------- incoming transfer ---------------- */\n.tr-crumb {\n  border: none;\n  background: none;\n  padding: 0;\n  cursor: pointer;\n  font: 600 12px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: var(--rf-brand);\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-bottom: 6px;\n}\n.tr-crumb:hover {\n  text-decoration: underline;\n}\n.tr-pill {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  border-radius: 999px;\n  padding: 3px 10px;\n  vertical-align: middle;\n  margin-left: 10px;\n}\n.tr-pill.is-pending { background: #f9f1de; color: #b0872f; }\n.tr-pill.is-accepted { background: #eaf1e9; color: #4d7a52; }\n.tr-pill.is-rejected { background: #f7ebe9; color: #a8483e; }\n.tr-pill.is-cancelled { background: #eeeae1; color: #8b8477; }\n\n.tr-grid {\n  margin: 18px 28px 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  gap: 18px;\n  align-items: start;\n}\n@media (max-width: 1100px) {\n  .tr-grid {\n    grid-template-columns: 1fr;\n  }\n}\n.tr-col {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  min-width: 0;\n}\n.tr-card {\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  padding: 18px 20px;\n}\n.tr-card-title {\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #8b8477;\n  margin: 0 0 12px;\n}\n.tr-kv {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 12px 20px;\n  margin: 0;\n}\n.tr-kv > div {\n  min-width: 0;\n}\n.tr-kv dt {\n  font-size: 11px;\n  color: #a29b8d;\n  margin: 0 0 2px;\n}\n.tr-kv dd {\n  font-size: 13.5px;\n  color: #191714;\n  margin: 0;\n  word-break: break-word;\n}\n.tr-kv dd.is-empty {\n  color: #bdb6a7;\n}\n.tr-note {\n  margin: 0;\n  padding: 12px 14px;\n  border-left: 3px solid var(--rf-brand-lite);\n  background: #fdfbf6;\n  border-radius: 0 8px 8px 0;\n  font-size: 13.5px;\n  color: #4a453c;\n  line-height: 1.45;\n}\n.tr-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.tr-table th {\n  text-align: left;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #8b8477;\n  padding: 6px 8px;\n  border-bottom: 1px solid #e7e3da;\n}\n.tr-table td {\n  padding: 8px;\n  border-bottom: 1px solid #f3f0e8;\n  vertical-align: top;\n}\n.tr-table tr:last-child td {\n  border-bottom: none;\n}\n.tr-table .is-num {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.tr-table .is-muted {\n  color: #8b8477;\n  font-size: 12px;\n}\n.tr-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.tr-actions .rf-btn {\n  width: 100%;\n}\n.rf-btn-danger {\n  padding: 0 14px;\n  border: 1px solid #e6c9c4;\n  background: #fff;\n  color: #a8483e;\n}\n.rf-btn-danger:hover {\n  background: #f7ebe9;\n}\n.rf-btn:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n.tr-textarea {\n  width: 100%;\n  min-height: 70px;\n  resize: vertical;\n  padding: 8px 10px;\n  border: 1px solid #e7e3da;\n  border-radius: 8px;\n  font: 400 13px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #191714;\n}\n.tr-textarea:focus {\n  outline: none;\n  border-color: var(--rf-brand-lite);\n}\n.tr-help {\n  font-size: 12px;\n  color: #8b8477;\n  margin: 0;\n  line-height: 1.45;\n}\n.tr-blockers {\n  border: 1px solid #ead9b3;\n  background: #fbf6ea;\n  border-radius: 10px;\n  padding: 12px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.tr-blockers-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: #7d5f24;\n  margin: 0;\n}\n.tr-blocker {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  font-size: 13px;\n  color: #4a453c;\n}\n.tr-blocker input {\n  margin-top: 3px;\n  accent-color: var(--rf-brand);\n}\n.tr-blocker ul {\n  margin: 4px 0 0;\n  padding-left: 16px;\n  font-size: 12px;\n  color: #6f6a60;\n}\n.tr-blocker.is-hard {\n  color: #a8483e;\n}\n.tr-result {\n  border: 1px solid #cfe0d0;\n  background: #eaf1e9;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #35563a;\n  line-height: 1.5;\n}\n.tr-result ul {\n  margin: 6px 0 0;\n  padding-left: 16px;\n}\n.tr-decided {\n  font-size: 13px;\n  color: #4a453c;\n  line-height: 1.5;\n}\n.tr-noperm {\n  border: 1px solid #e7e3da;\n  background: #fdfcfa;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-size: 13px;\n  color: #6f6a60;\n  line-height: 1.5;\n}\n.tr-state {\n  margin: 24px 28px;\n  color: #8b8477;\n  font-size: 13.5px;\n}\n\n/* incoming transfers list */\n.tr-list {\n  margin: 18px 28px 0;\n  background: #fff;\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n.tr-list .tr-table th:first-child,\n.tr-list .tr-table td:first-child {\n  padding-left: 18px;\n}\n.tr-list .tr-table th:last-child,\n.tr-list .tr-table td:last-child {\n  padding-right: 18px;\n}\n.tr-list .tr-table td {\n  padding-top: 11px;\n  padding-bottom: 11px;\n}\n.tr-row {\n  cursor: pointer;\n}\n.tr-row:hover td {\n  background: #fdfbf6;\n}\n.tr-serial {\n  font-weight: 600;\n  white-space: nowrap;\n}\n.tr-list .tr-pill {\n  margin-left: 0;\n}\n\n/* ---------------- transfers page tabs ---------------- */\n.tr-tabs {\n  display: flex;\n  gap: 4px;\n  margin-top: 18px;\n  border-bottom: 1px solid #e8e2d6;\n}\n.tr-tab {\n  border: none;\n  background: transparent;\n  padding: 9px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #8b8477;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  transition: color 150ms, border-color 150ms;\n}\n.tr-tab:hover {\n  color: #5d574c;\n}\n.tr-tab.is-active {\n  color: var(--rf-brand-deep);\n  border-bottom-color: var(--rf-brand-lite);\n}\n.tr-list .tr-table .tr-rowact {\n  text-align: right;\n  white-space: nowrap;\n}\n.tr-list .tr-table .tr-rowact .rf-btn {\n  padding: 3px 12px;\n  font-size: 12px;\n}\n\n/* ---------------- transfer request modal (source side) ---------------- */\n.tx-wrap {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n.tx-scrim {\n  position: absolute;\n  inset: 0;\n  background: rgba(25, 23, 20, 0.48);\n}\n.tx-modal {\n  position: relative;\n  width: min(520px, 100%);\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  background: #fffdf8;\n  border: 1px solid #e8e2d6;\n  border-radius: 14px;\n  box-shadow: 0 24px 60px rgba(25, 23, 20, 0.28);\n  overflow: hidden;\n}\n.tx-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px 22px 16px;\n  border-bottom: 1px solid #efeae0;\n}\n.tx-head > div {\n  flex: 1;\n  min-width: 0;\n}\n.tx-eyebrow {\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #a39a89;\n}\n.tx-title {\n  font-size: 24px;\n  line-height: 1.15;\n  margin: 4px 0 0;\n  font-weight: 400;\n  color: #191714;\n}\n.tx-sub {\n  margin: 4px 0 0;\n  font-size: 12.5px;\n  color: #6f6a60;\n}\n.tx-body {\n  padding: 18px 22px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n.tx-lede {\n  margin: 0;\n}\n.tx-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.tx-choices {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.tx-choice {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 10px 13px;\n  border: 1px solid #e8e2d6;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  transition: border-color 150ms, background 150ms;\n}\n.tx-choice:hover {\n  border-color: #d8ccb4;\n}\n.tx-choice.is-on {\n  border-color: var(--rf-brand-lite);\n  background: #fbf6ea;\n}\n.tx-choice input {\n  accent-color: var(--rf-brand-lite);\n  margin: 0;\n}\n.tx-choice-mark {\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  background: #f0e3c8;\n  color: var(--rf-brand-deep);\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.tx-choice-name {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #35312a;\n  min-width: 0;\n}\n.tx-exists {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 14px 16px;\n  border-radius: 10px;\n  background: #f9f1de;\n  border: 1px solid #ecdcb8;\n}\n.tx-exists b {\n  font-size: 13.5px;\n  color: var(--rf-brand-deep);\n}\n.tx-exists p {\n  margin: 0;\n  font-size: 12.5px;\n  color: #8a7f6a;\n  line-height: 1.5;\n}\n.tx-foot {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 22px;\n  border-top: 1px solid #efeae0;\n  background: #faf6ee;\n}\n.tx-modal .tr-textarea {\n  min-height: 74px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
